import React from 'react'
import PropTypes from 'prop-types';
import PageContainer from '../../../layout/PageContainer';
import SolicitudesProrroga from './SolicitudesProrroga';


const SolicitudesProrrogaContainer = ({ match: { params: { policyId } } }) => (
  <PageContainer
    breadcrumbs={[
      { id: 0, name: 'SEGURO DE CRÉDITO', url: '/' },
      { id: 1, name: 'PRÓRROGAS', url: '/asegurado/polizas-credito' },
      { id: 2, name: 'SOLICITUDES PRÓRROGA' },
    ]}
    clientFilter={{
      type: 'asegurado',
      ramo: 'credito',
      showFilter: false,
    }}
  >
    {(client) => (
      <SolicitudesProrroga 
        policyId={policyId || null} 
        client={client} 
        locationSearch={window.location.search} 
      />
    )}
  </PageContainer>
);

SolicitudesProrrogaContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      policyId: PropTypes.string,
    }),
  }).isRequired,
};
SolicitudesProrrogaContainer.defaultProps = {
  policyId: '',
};

export default SolicitudesProrrogaContainer;
